module.exports = __webpack_public_path__ + "static/media/wizualizacja-119.1b26dfb0.png";